import Vue from 'vue'
import VueRouter from 'vue-router'
import { commonRouter } from "./routes"
import { getStorage, setStorage } from '@/storage'
import store from '@/store'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: commonRouter
})

router.beforeEach((to, from, next) => {
  console.log(to)
  if (getStorage('token')) {
    to.path === "/login" ? next('/home') : next()
  } else {
    to.path === "/login" ? next() : next('/login')
  }
})
//处理动态路由
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.reload()
  }
})
export default router

